export const environment = {
  production: true,
  robotsIndex: true,
  siteUrl: 'https://livin-france.com/',
  apiURL: 'https://university-api.livin-france.com/api/',
  api2URL: 'https://university-api.livin-france.com/api/',
  tekloURL: 'https://teklo.livin-france.com/api/',
  mediaURL: 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/school/',
  rawMediaURL: 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/',
  mediaFilesURL: 'https://university-api.livin-france.com/files/',
  mixpanelToken: '12a93eb804055d16dc747cc243e7d91a',
  stripeKey: 'pk_live_jRPQ5cSZFRUXRihy9Jvy6oiq',
  payPalId: 'AfLRARqqG6SijkMn1Wm434Yqdlz-IVjubwbMJ-D88CcIVciwV92sgJxln74qQw9TXSKaBSYe6XsWZcEP',
  recaptcha: {
    siteKey: '6LdEfVgpAAAAAEppQhZKXJnGnUMWnYl0A40FbsL9',
  },
};
